"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.transformHtmlContent = void 0;
var _utils = require("../components/shared/TextBox/utils");
const transformHtmlContent = (html)=>{
    if (!(html === null || html === void 0 ? void 0 : html.text)) {
        return null;
    }
    const { text, textLinks } = html;
    const replaceLinks = (0, _utils.replaceLinks)(textLinks);
    return replaceLinks(text);
};
exports.transformHtmlContent = transformHtmlContent;
